import script from "./QuotationAddBill.vue?vue&type=script&setup=true&lang=js"
export * from "./QuotationAddBill.vue?vue&type=script&setup=true&lang=js"

import "./QuotationAddBill.vue?vue&type=style&index=0&id=da6ec792&scoped=true&lang=css"

import exportComponent from "/Users/amsrafid/Projects/www/miaccounts-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-da6ec792"]])

export default __exports__